// extracted by mini-css-extract-plugin
export default {"container":"CryptoSelectBlock_container__qUywa"};